async function getUserName(param) {
  const response = await fetch(
    process.env.REACT_APP_WWW_URL + '/wp-json/wp/v2/users/' + param
  );

  return await response.json();
}

export default getUserName;
